import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const useUniversalMfaEnabled = (): boolean => {
    const { isPageBlocked } = usePricingModulesState();

    return !isPageBlocked(LAYOUT_TABS.UNIVERSAL_MFA_DASHBOARD.ID);
};
